module.exports = __webpack_public_path__ + "static/media/details.b83d9b6d.png";